<template>
  <div class="dashboard">
    <h2 class="profile__header">{{ $t('common.cabinet') }}</h2>
    <div v-if="slidersLoading" class="text-center mt-5 d-flex justify-content-center">
      <b-spinner
          variant="primary"
      ></b-spinner>
    </div>
    <div class="dashboard__wrapper row align-items-start">
      <carousel v-if="sliders && sliders.length > 0" class="dashboard__slider col-md-12" :perPage="1" :autoplay="true"
                :loop="true" :autoplayTimeout="5000" :autoplayHoverPause="true">
        <template v-if="sliders">
          <slide class="dashboard__slide" v-for="slider in sliders" :key="slider.id">
            <img :src="slider.image" alt="">
            <a target="_blank" class="content" :href="slider.link">
              <div class="name">
                {{ slider.text }}
              </div>
              <div v-if="slider.price" class="price">
                {{ slider.price }} грн
                <span v-if="slider.discount" class="sale">−{{ slider.discount }}%</span>
              </div>
            </a>
          </slide>
        </template>
      </carousel>
    </div>

    <div class="row mb-3">
      <div v-if="lastVisitsCurrent && lastVisitsCurrent.length > 0" class="col-md-6">
        <div class="entry__wrapper">
          <h3>{{ $t('visits.nearest_records') }}</h3>

          <template v-if="lastVisitsCurrent">
            <div class="entry" v-for="lastVisitCurrent in lastVisitsCurrent">
              <div class="entry__header">
                <template v-if="isToday(lastVisitCurrent.date_time)">
                  <span class="danger">{{ $t('common.today_in') }} {{ formatTime(lastVisitCurrent.date_time) }}</span>
                </template>
                <template v-else>
                  {{ formatDate(lastVisitCurrent.date_time) }} в {{ formatTime(lastVisitCurrent.date_time) }}
                </template>

                <span v-if="lastVisitCurrent.specialization">{{ $t('consultations.consultation') }}</span>
                <span v-if="lastVisitCurrent.diagnostic">{{ $t('diagnostic.diagnostic') }}</span>
              </div>

              <div v-if="lastVisitCurrent.specialization" class="entry__tsaveitle">
                <span>{{ lastVisitCurrent.name }}</span>
                <br>
                <span class="entry__title_light">{{ getDoctorName(lastVisitCurrent.doctor_id) }}</span>
              </div>

              <div v-if="lastVisitCurrent.diagnostic" class="entry__title">
                <span>{{ lastVisitCurrent.name }}</span>
              </div>

              <div class="entry__place">
                {{ getClinicName(lastVisitCurrent.clinic) }}
              </div>

              <!--<button class="icon__close" @click="selectVisitCurrent(lastVisitCurrent)"></button>-->
            </div>
          </template>

          <router-link class="btn-blue" :to="{name:'profile.visits.current'}">
            {{ $t('buttons.all_visits') }}
          </router-link>
        </div>
      </div>

      <div v-if="lastAnalyzes && lastAnalyzes.length > 0" class="col-md-6">
        <div v-if="!lastAnalyzesLoading" class="entry__wrapper">
          <h3>{{ $t('analyzes.last_analyzes') }}</h3>

          <template v-if="lastAnalyzes">
            <div class="entry entry-old" v-for="lastAnalyze in lastAnalyzes">
              <div class="entry__header">
                <template v-if="isToday(lastAnalyze.date)">
                  <span class="danger">{{ $t('common.today') }}</span>
                </template>
                <template v-else>
                  {{ formatDate(lastAnalyze.date) }}
                </template>
              </div>

              <div class="entry__title">
                <span>{{ lastAnalyze.title }}</span>
              </div>

              <div class="entry__download">
                <button @click="openAnalyzeModal(lastAnalyze)" class="icon__info"></button>
              </div>
            </div>
          </template>

          <router-link class="btn-blue" :to="{name:'profile.analyzes'}">
            {{ $t('buttons.all_analyzes') }}
          </router-link>
        </div>
        <div v-else class="text-center mt-5 d-flex justify-content-center">
          <b-spinner
              variant="primary"
          ></b-spinner>
        </div>
      </div>

    </div>
    <div v-if="lastVisitsCurrent && lastVisitsCurrent.length === 0 && lastAnalyzes && lastAnalyzes.length === 0">
      <div class="row">
        <div class="col-4 d-flex justify-content-end">
          <img src="~@/assets/images/zero-illu-01.svg" alt="">
        </div>
        <div class="col-6">
          <div class="mb-3">
            {{ $t('common.dashboard_text') }}:
          </div>
          <router-link :to="{name:'profile.order.find-doctor'}" class="btn mr-3 w-auto">
            {{ $t('buttons.book_consultation') }}
          </router-link>
          <router-link :to="{name:'profile.order.find-diagnostic'}" class="btn w-auto">
            {{ $t('buttons.book_diagnostic') }}
          </router-link>
        </div>
      </div>
    </div>

    <b-modal ref="confirmationModal" centered hide-footer :title="$t('common.confirm')">
      {{ $t('common.a_u_sure') }}

      <div class="mt-3">
        <button class="btn-blue" @click="cancelVisitCurrent()">{{ $t('common.yes') }}</button>
      </div>
    </b-modal>
    <b-modal ref="analyzeModal" centered size="lg" hide-footer :title="$t('common.docs')">
      <div class="loading" v-if="selectedAnalyzeContentLoading">
        {{ $t('common.loading') }}
      </div>

      <iframe class="content w-100 h-auto" style="min-height: 500px" ref="analyzeContent"></iframe>

      <div class="mt-3">
        <button class="btn-blue mr-1" v-if="selectedAnalyzeContent" @click="analyzeDownload()">
          {{ $t('buttons.download') }}
        </button>
        <button class="btn-blue" @click="hideAnalyzeModal()">{{ $t('buttons.hide') }}</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Carousel from 'vue-carousel/src/Carousel';
import Slide from 'vue-carousel/src/Slide';
import moment from 'moment';
import config from '@/helpers/configDateFormats'
import fileSave from "@/helpers/fileSave";

export default {
  name: 'dashboard',
  data() {
    return {
      selectedVisitCurrentCancel: null,
      lastAnalyzesLoading: false,
      slidersLoading: false,
      selectedAnalyzeContentLoading: false,
      selectedAnalyzeContent: null,
      selectedAnalyze: null,

    };
  },
  computed: {
    ...mapState({
      lastAnalyzes(state) {
        this.lastAnalyzesLoading = false
        if (state.analyzes.analyzesList) {
          return state.analyzes.analyzesList.slice(0, 3);
        }

        return [];
      },
      lastVisitsCurrent(state) {
        let consultations = []
        let diagnostics = []
        if (state.visits.visitsSpecialization.data['PLN'] && state.visits.visitsSpecialization.data['PLN'].length) {
          consultations = state.visits.visitsSpecialization.data['PLN']
        }
        if (state.visits.visitsDiagnostic.data['PLN'] && state.visits.visitsDiagnostic.data['PLN'].length) {
          diagnostics = state.visits.visitsDiagnostic.data['PLN']
        }
        let visits = consultations.concat(diagnostics);
        let sliceIndex = visits.length < 3 ? visits.length : 3
        return visits.slice(0, sliceIndex);
      },
      sliders(state) {
        if (state.settings.sliders && state.settings.sliders.length > 0) {
          this.slidersLoading = false
          return state.settings.sliders
        }
        return []
      }
      ,
    }),
    ...mapGetters([
      'doctors',
      'clinics'
    ])
  },
  methods: {
    formatDate(date) {
      return moment(date).format(config.DATE_FORMAT_OUTPUT);
    }
    ,
    getDoctorName(doctor_id) {
      let doctor = this.doctors.find((item) => item.odrex_id === doctor_id)

      return doctor ? doctor.name : ''
    }
    ,
    getClinicName(id) {
      let clinic = this.clinics.find((item) => item.id === id)

      return clinic ? clinic.short_title : ''
    }
    ,
    formatTime(date) {
      return moment(date).format(config.TIME_FORMAT);
    }
    ,
    isToday(date) {
      return moment(date).format(config.DATE_FORMAT) === moment(new Date()).format(config.DATE_FORMAT);
    }
    ,
    analyzeDownload() {
      let analyze = this.selectedAnalyze
      this.$store
          .dispatch('getAnalyzeDocument', analyze)
          .then(content => {
            let byteCharacters = atob(content.data);
            let byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            fileSave({
              blob: byteArray,
              type: 'application/pdf',
              name: analyze.title,
            });
          })
    }
    ,
    openAnalyzeModal(analyze) {
      this.selectedAnalyze = analyze
      this.$refs.analyzeModal.show();
      this.$store
          .dispatch('getAnalyzeDocument', analyze)
          .then(content => {
            this.selectedAnalyzeContent = content.data;
            this.selectedAnalyzeContentLoading = false;
            let byteCharacters = atob(content.data);
            let byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            let file = new Blob([byteArray], {type: 'application/pdf;base64'});
            this.$refs.analyzeContent.src = URL.createObjectURL(file);
          })
    },

    hideAnalyzeModal() {
      this.$refs.analyzeModal.hide();
      this.selectedAnalyzeContent = null;
      this.selectedAnalyze = null
      this.$refs.analyzeContent.src = '';
    },
    selectVisitCurrent(visit) {
      this.selectedVisitCurrentCancel = visit;
      this.$refs.confirmationModal.show();
    }
    ,
    cancelVisitCurrent() {
      this.$store
          .dispatch('setVisitCurrentCancel', this.selectedVisitCurrentCancel)
          .then(() => {
            this.$refs.confirmationModal.hide();

            this.$store
                .dispatch('getVisitsCurrent');
          });
    }
    ,
  }
  ,
  created() {
    this.lastAnalyzesLoading = true
    this.slidersLoading = true
  }
  ,
  components: {
    Carousel,
    Slide,
  }
}
</script>
